import {Directive, Input, HostListener} from "@angular/core";
import {environment} from "../../environments/environment";

@Directive({
  selector: '[outlink]'
})
export class OutlinkDirective {
  @Input() outlink;

  @HostListener('click', ['$event']) onClick(event) {
    if(environment.app) {
      event.preventDefault();

      cordova.InAppBrowser.open(this.outlink, '_blank', '');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/directive/outlink.directive.ts